export const SEARCH_MODEL_ASYNC = 'SEARCH_MODEL_ASYNC';
export const SEARCH_MODEL_SUCCESS = 'SEARCH_MODEL_SUCCESS';
export const SEARCH_ROOM_MODEL_ASYNC = 'SEARCH_ROOM_MODEL_ASYNC';
export const SEARCH_ROOM_MODEL_SUCCESS = 'SEARCH_ROOM_MODEL_SUCCESS';
export const CREATE_MODEL_ASYNC = 'CREATE_MODEL_ASYNC';
export const UPDATE_MODEL_ASYNC = 'UPDATE_MODEL_ASYNC';
export const DELETE_MODEL_ASYNC = 'DELETE_MODEL_ASYNC';
export const GET_MODEL_BY_ID_ASYNC = 'GET_MODEL_BY_ID_ASYNC';
export const GET_MODEL_BY_ID_SUCCESS = 'GET_MODEL_BY_ID_SUCCESS';
export const CREATE_UPDATE_MODEL_ERROR = 'CREATE_MODEL_ERROR';
export const ADD_ROOM_TO_MODEL_ERROR = 'ADD_ROOM_TO_MODEL_ERROR';
export const REMOVE_ROOM_OUT_OF_MODEL_ASYNC = 'REMOVE_ROOM_OUT_OF_MODEL_ASYNC';
export const ADD_ROOM_TO_MODEL_ASYNC = 'ADD_ROOM_TO_MODEL_ASYNC';
export const OPEN_POPUP_ROOM_MODEL = 'OPEN_POPUP_ROOM_MODEL';
export const RESET_MODEL = 'RESET_MODEL';
export const GET_LIST_MODEL_BY_PROJECT_ASYNC = 'GET_LIST_MODEL_BY_PROJECT_ASYNC';
export const GET_LIST_MODEL_BY_PROJECT_SUCCESS = 'GET_LIST_MODEL_BY_PROJECT_SUCCESS';
export const RESET_ERROR_MESSAGE_MODEL = 'RESET_ERROR_MESSAGE_MODEL';




// WEBPACK FOOTER //
// ./src/Model/constants.js